module.exports = __webpack_public_path__ + "static/media/android-chrome-256x256.b4601fe2.png";